import { __extends } from "tslib";
import { LoaderInfo as LoaderInfoAway } from "@awayjs/core";
var LoaderInfo = /** @class */ (function (_super) {
    __extends(LoaderInfo, _super);
    function LoaderInfo() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.swfVersion = 0;
        return _this;
    }
    LoaderInfo.prototype.getSymbolById = function (id) {
    };
    ;
    return LoaderInfo;
}(LoaderInfoAway));
export { LoaderInfo };
